import type { ChekiPricing, ChekiType } from '@tsuyosa/types';

interface Props {
  pricing: ChekiPricing[];
  value: ChekiType;
  onChange: (t: ChekiType) => void;
}

const TYPE_LABELS: Record<ChekiType, string> = {
  '2shot_solo': '2-Shot Solo',
  'all_member': 'All Member',
};

function formatPrice(n: number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency', currency: 'IDR', maximumFractionDigits: 0,
  }).format(n);
}

export function ChekiTypeSelector({ pricing, value, onChange }: Props) {
  if (pricing.length === 0) return null;

  return (
    <div>
      <p className="mb-2 text-[10px] uppercase tracking-[0.3em] text-white/40">Tipe Cheki</p>
      <div className="flex overflow-hidden rounded-xl border" style={{ borderColor: 'var(--border)' }}>
        {pricing.map((p, i) => {
          const selected = p.type === value;
          return (
            <button
              key={p.type}
              type="button"
              onClick={() => onChange(p.type)}
              className={[
                'flex flex-1 flex-col items-center px-2 py-3 text-center transition-all',
                i > 0 ? 'border-l' : '',
                selected ? 'text-white' : 'text-white/50 hover:text-white/70',
              ].join(' ')}
              style={{
                background: selected
                  ? 'linear-gradient(135deg, var(--pink), var(--pink-dark))'
                  : 'var(--surface)',
                borderColor: 'var(--border)',
              }}
            >
              <span className="text-sm font-semibold">{TYPE_LABELS[p.type]}</span>
              <span className="mt-0.5 text-xs opacity-70">{formatPrice(p.price_preorder)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
